export const GET_PORTAL_DATA = 'GET_PORTAL_DATA'
export const GET_PORTALS_DATA = 'GET_PORTALS_DATA'
export const CREATE_PORTAL_DATA = 'CREATE_PORTAL_DATA'
export const UPDATE_PORTAL_DATA = 'UPDATE_PORTAL_DATA'
export const SET_PORTAL_DATA = 'SET_PORTAL_DATA'
export const SET_PORTAL_ERROR = 'SET_PORTAL_ERROR'
export const SET_PORTAL_PROCESSING = 'SET_PORTAL_PROCESSING'

export function getPortalData (uid) {
  return {
    type: GET_PORTAL_DATA,
    payload: uid,
  }
}

export function getPortalsData (query) {
  return {
    type: GET_PORTALS_DATA,
    payload: query,
  }
}

export function updatePortalData ({ data }) {
  return {
    type: UPDATE_PORTAL_DATA,
    payload: data,
  }
}

export function createPortalData ({ data }) {
  return {
    type: CREATE_PORTAL_DATA,
    payload: data,
  }
}

export function setPortalData ({ data }) {
  return {
    type: SET_PORTAL_DATA,
    payload: data,
  }
}

export function setPortalError ({ error }) {
  return {
    type: SET_PORTAL_ERROR,
    payload: error,
  }
}

export function setPortalProcessing ({ processing = true }) {
  return {
    type: SET_PORTAL_PROCESSING,
    payload: processing,
  }
}
